import { PrintExampleDto } from '@/api-sdk';
import { createContext } from '@lit/context';

export type UploadServiceContext =
  | {
      service: Promise<string> | Promise<PrintExampleDto> | undefined;
      controller: AbortController;
    }
  | undefined;

export const uploadService =
  createContext<UploadServiceContext>('upload-service');
